<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div>
        <div class="card">
          <div class="card-header" v-if="isAdmin">
            <a-button type="primary" @click="goToNew">
              + Tambah Artikel
            </a-button>
          </div>
          <div class="card-body">
            <tabel-artikel />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabelArtikel from '@/components/tables/artikel'
import router from '@/router'

export default {
  components: {
    TabelArtikel,
  },
  data: function () {
    return {
      isAdmin: false,
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    goToNew() {
      router.push('/artikel/tambah')
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      // console.log(role)
      if (role === 'admin' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
  },
}
</script>
